import { useMemo } from 'react';
import Navigation from '@/components/Navigation';
import HeroSection from '@/components/HeroSection';
import BrandStatement from '@/components/BrandStatement';
import FeaturedInstruments from '@/components/FeaturedInstruments';
import AtelierTeaser from '@/components/AtelierTeaser';
import ContactTeaser from '@/components/ContactTeaser';
import Footer from '@/components/Footer';
import PageSEO from '@/components/PageSEO';
import MaintenancePage from './Maintenance';
import { useSiteSettings } from '@/hooks/useSiteSettings';
import { useAuth } from '@/hooks/useAuth';
import { buildOrganization, buildWebSite, buildWebPage, buildGraph, SEO_LANGUAGE } from '@/utils/jsonLd';
import { translations } from '@/i18n/translations';

const Index = () => {
  const { settings, loading } = useSiteSettings();
  const { isAdmin } = useAuth();
  const seoT = translations[SEO_LANGUAGE];

  const jsonLd = useMemo(() => buildGraph(
    buildOrganization(settings),
    buildWebSite(),
    buildWebPage('/', seoT.metaTitle, seoT.metaDescription),
  ), [settings]);

  if (!loading && settings.maintenance_mode && !isAdmin) {
    return <MaintenancePage />;
  }

  return (
    <main className="min-h-screen flex flex-col bg-background">
      <PageSEO path="/" jsonLd={jsonLd} />
      <Navigation />
      <HeroSection />
      {settings.section_brand_statement_visible && <BrandStatement />}
      {settings.section_featured_visible && <FeaturedInstruments />}
      {settings.section_atelier_teaser_visible && <AtelierTeaser />}
      {settings.section_contact_teaser_visible && <ContactTeaser />}
      <Footer />
    </main>
  );
};

export default Index;
